import React from 'react';
import propTypes from 'prop-types';
import { unitValue } from 'constants/types';
import classNames from 'classnames';
import moment from 'moment';

import IncludeData from './IncludeData';
import DataType from './DataType';
import { getMessage } from 'util/locale';

export function getTranslationKey(seasonCode) {
  const seasonSegments = seasonCode.split(':');
  const shortSeasonName = seasonSegments[4]; // WNT, SUM, etc
  const seasonTranslationKey = `season__${shortSeasonName}`;
  return seasonTranslationKey;
}

export function getSeasonNameTranslation(seasonCode) {
  const seasonTranslationKey = getTranslationKey(seasonCode);
  const seasonName = getMessage(seasonTranslationKey);
  return seasonName;
}

const baseString = 'vra-harvest-history-yield-row';
const classString = classNames({
  [`${baseString}`]: true
});

const includeDataClassName = 'vra-history-multi-season-table--include';
const dataTypeClassName = 'vra-history-multi-season-table--data-type';
const cropHarvestedClassName = 'vra-history-multi-season-table--crop-harvested';
const cropHarvestedSeasonClassName = 'vra-history-multi-season-table--crop-harvested-season';
const dateHarvestedClassName = 'vra-history-multi-season-table--date-harvested';

const HistoryYieldRow = ({
  averageYield,
  cropName,
  cropNominalWeight,
  date,
  displayHarvestDate = false,
  isIncluded,
  layerType,
  onToggleLayerInclusion,
  season
}) => {

  const seasonName = getSeasonNameTranslation(season);

  return (
    <tr className={classString} key={ season }>
      {/* include */}
      <td className={includeDataClassName}>
        <IncludeData
          cropName={cropName}
          isIncluded={isIncluded}
          layerType={layerType}
          onToggleLayerInclusion={onToggleLayerInclusion}
          season={season}
        />
      </td>
      {/* Data Type */}
      <td className={dataTypeClassName}>
        <DataType
          averageYield={averageYield}
          cropNominalWeight={cropNominalWeight}
          layerType={layerType}
          season={season}
        />
      </td>
      {/*  crop harvested */}
      <td className={cropHarvestedClassName}>
        <section>
          <div>
            { cropName }
          </div>
          {seasonName && <div className={cropHarvestedSeasonClassName}>
            {seasonName}
          </div>}
        </section>
      </td>
      {displayHarvestDate && (<td className={dateHarvestedClassName}>
        { moment(date).format('MMM D, YYYY') }
      </td>)}
    </tr>
  );
};

HistoryYieldRow.propTypes = {
  averageYield: unitValue, // If not specified, it means yield data is not available.
  cropName: propTypes.string.isRequired,
  cropNominalWeight: propTypes.number.isRequired,
  date: propTypes.string.isRequired,
  displayHarvestDate: propTypes.bool,
  isIncluded: propTypes.bool.isRequired,
  layerType: propTypes.string.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired,
  season: propTypes.string.isRequired
};

export default HistoryYieldRow;
